<canvas #canvasEle class="confetti-canvas" width="800" height="600"></canvas>